(function processHistoryControllerDefinition() {
    'use strict';

    angular.module('Process')
        .controller('ProcessHistoryController', [
            '$filter', '$state', '$scope', '$stateParams', 'errorsExtend', 'processService', '$translate', '$window',
    function certificateHistoryController($filter, $state, $scope, $stateParams, errors, processService, $translate, $window) {

        $scope.logs = []
        $scope.showPagination = true
        $scope.data = {
            currentPage: 1,
            totalItems: 0,
            itemPerPage: 13,
            from: 0
        }

        $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
        .then(function (translated) {
            $scope.paginatorTranslations = {
                nextText: translated.PaginationNext,
                previousText: translated.PaginationPrev,
                lastText: translated.PaginationLastFem,
                firstText: translated.PaginationFirstFem
            };
        });

        $scope.load = function () {
            return processService.getHistory($stateParams.id, $scope.data.currentPage, $scope.data.itemPerPage).then(function (result) {
                $scope.data.totalItems = result.count;
                $scope.data.from = 1 + ($scope.data.itemPerPage * ($scope.data.currentPage - 1));

                $scope.logs = [];

                result.values.forEach(function (item) {
                    item.firstResult = (item.results && item.results.length > 0) ? item.results[0] : undefined;
                });

                if ($scope.data.currentPage == 1) {
                    result.values[0].endDate = "";
                }

                $scope.logs = result.values;
                $scope.goToDetail = $stateParams.goToDetail;
            }, function (error) {
                errors.showError(error);
            });
        };

        $scope.view = function () {
            if ($scope.goToDetail == 3) {
                $state.go('paycheck-rrhh-detail', { id: $stateParams.id });
            } else {
                $state.go('certificate-rrhh-detail', { id: $stateParams.id });
            }
        };

        $scope.cancel = function () {
            $window.history.back();
        };

        $scope.load();
    }
        ]);
})();